import { render, staticRenderFns } from "./PostTagPicker.vue?vue&type=template&id=12538b5c&"
import script from "./PostTagPicker.vue?vue&type=script&lang=js&"
export * from "./PostTagPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports